
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("1eKr8", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-GB.fad38f48.js.map
